import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "mb-4 border-b border-black-200 pb-24" }
const _hoisted_2 = {
  key: 0,
  class: "mt-16"
}
const _hoisted_3 = {
  key: 0,
  class: "block pb-12 text-20 font-medium text-black-900"
}
const _hoisted_4 = { class: "flex flex-wrap justify-between gap-8 laptop:gap-16" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "mt-32 flex items-center gap-x-12 uppercase" }
const _hoisted_7 = {
  key: 0,
  class: "text-16 text-black-400"
}
const _hoisted_8 = {
  key: 1,
  class: "text-16 text-black-400"
}
const _hoisted_9 = {
  key: 2,
  class: "text-26 font-medium text-black-900"
}
const _hoisted_10 = {
  key: 3,
  class: "text-26 font-medium text-black-900"
}
const _hoisted_11 = {
  key: 4,
  class: "badge-small badge-pill badge-primary font-medium uppercase"
}
const _hoisted_12 = {
  name: "add",
  class: "btn btn-primary btn-pill w-full py-8 text-18 capitalize"
}
const _hoisted_13 = {
  key: 0,
  class: "fixed bottom-0 left-0 right-0 z-[99] p-16 tablet:hidden"
}
const _hoisted_14 = {
  name: "add",
  class: "btn btn-primary btn-pill w-full py-8 text-18 capitalize"
}
const _hoisted_15 = ["value"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.product.variants.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          ($props.valueHeadline)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($props.valueHeadline), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.product.variants, (variant, index) => {
              return (_openBlock(), _createElementBlock("button", {
                key: variant.id,
                type: "button",
                class: _normalizeClass(["btn-xsmall laptop:btn-medium btn-rounded relative flex-1 border border-black-900 hover:bg-black-200 hover:text-black-900", 
            index === $data.variantIndex
              ? 'btn-primary pointer-events-none hover:bg-black-900 hover:text-white'
              : 'btn-secondary'
          ]),
                onClick: $event => ($options.selectVariant(index))
              }, _toDisplayString(variant.title), 11, _hoisted_5))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      ($options.formattedDiscountedPrice)
        ? (_openBlock(), _createElementBlock("del", _hoisted_7, _toDisplayString($options.formattedPrice), 1))
        : ($options.discountPercentage)
          ? (_openBlock(), _createElementBlock("del", _hoisted_8, _toDisplayString($options.formattedCompareAtPrice), 1))
          : _createCommentVNode("", true),
      ($options.formattedDiscountedPrice)
        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString($options.formattedDiscountedPrice), 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_10, [
            _createElementVNode("span", null, _toDisplayString($options.formattedPrice), 1)
          ])),
      ($options.discountPercentage)
        ? (_openBlock(), _createElementBlock("span", _hoisted_11, " -" + _toDisplayString($options.discountPercentage) + "% ", 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("form", {
      ref: "addToCartForm",
      name: "add_to_cart",
      class: "pt-24",
      onSubmit: _cache[0] || (_cache[0] = _withModifiers($event => ($options.addToCart($event)), ["prevent"]))
    }, [
      _createElementVNode("button", _hoisted_12, _toDisplayString($data.locale.add_to_cart), 1),
      ($props.stickyEnabled)
        ? (_openBlock(), _createBlock(_Transition, {
            key: 0,
            name: "fade"
          }, {
            default: _withCtx(() => [
              ($data.isButtonSticky)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("button", _hoisted_14, _toDisplayString($data.locale.add_to_cart), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("input", {
        type: "hidden",
        name: "id",
        value: $options.currentVariant.id
      }, null, 8, _hoisted_15)
    ], 544),
    _renderSlot(_ctx.$slots, "default")
  ]))
}